import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginView from "./views/LoginView";
import Dashboard from "./views/Dashboard";
import ListProviderView from "./views/providers/ListProvidersView";
import ShowProviderView from "./views/providers/ShowProviderView";
import CreateProviderView from "./views/providers/CreateProviderView";
import UpdateProviderView from "./views/providers/UpdateProviderView";
import ListClientView from "./views/customers/ListClientsView";
import ShowClientView from "./views/customers/ShowClientView";
import UpdateClientView from "./views/customers/UpdateClientView";
import ListAppointmentsView from "./views/appointments/ListAppointmentsView";
import ShowAppointementView from "./views/appointments/ShowAppointmentView";
import ListAdminsView from "./views/admins/ListeAdminsView";
import CreateAdminView from "./views/admins/CreateAdminView";
import UpdateAdminView from "./views/admins/UpdateAdminView";
import ShowAdminView from "./views/admins/ShowAdminView";
import SettingsView from "./views/settings/SettingsView";
import ListCategoriesView from "./views/categories/ListCategoriesView";
import CreateCategoryView from "./views/categories/CreateCategoryView";
import UpdateCategoryView from "./views/categories/UpdateCategoryView";
import ShowCategoryView from "./views/categories/ShowCategoryView";
import ListAnnouncementsView from "./views/annonces/ListAnnouncementsView";
import ShowAnnouncement from "./views/annonces/ShowAnnouncementView";
import UpdateCommissionView from "./views/commissions/UpdateCommissionView";
import ListCommandesView from "./views/commandes/ListCommandesView";
import CreateCommandeView from "./views/commandes/CreateCommandeView";
import UpdateCommandeView from "./views/commandes/UpdateCommandeView";
import DetailsCommandeView from "./views/commandes/DetailsCommandeView";
import AddAnnonce from "./views/annonces/AddAnnonce";
import AnnonceDetails from "./views/annonces/AnnonceDetails";
import EditAnnonce from "./views/annonces/EditAnnonce";
import FormationList from "./views/formations/FormationList";
import AddFormation from "./views/formations/AddFormation";
import FormationDetails from "./views/formations/FormationDetails";
import EditFormation from "./views/formations/EditFormation";
import ListFraisAbonnementsView from "./views/frais_abonnements/ListFraisAbonnementsView";
import ListFacturesView from "./views/factures/ListFacturesView";
import DetailsFactureView from "./views/factures/DetailsFactureView";
import ListConditionsGeneralesView from "./views/legal/ListConditionsGeneralesView";
import CreateConditionGeneraleView from "./views/legal/CreateConditionGeneraleView";
import UpdateConditionGeneraleView from "./views/legal/UpdateConditionGeneraleView";
import DetailsConditionGeneraleView from "./views/legal/DetailsConditionGeneraleView";
import ListDevisesView from "./views/devises/ListDevisesView";
import CreateDeviseView from "./views/devises/CreateDeviseView";
import UpdateDeviseView from "./views/devises/UpdateDeviseView";
import DetailsDeviseView from "./views/devises/DetailsDeviseView";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />}></Route>
        <Route path="/login" element={<LoginView />}></Route>
        <Route path="/gestion-prestataires/liste" element={<ListProviderView />}></Route>
        <Route path="/gestion-prestataires/:id/details" element={<ShowProviderView />}></Route>
        <Route path="/gestion-prestataires/creation" element={<CreateProviderView />}></Route>
        <Route path="/gestion-prestataires/:id/edit" element={<UpdateProviderView />}></Route>

        <Route path="/gestion-clients/liste" element={<ListClientView />}></Route>
        <Route path="/gestion-clients/:id/details" element={<ShowClientView />}></Route>
        <Route path="/gestion-clients/:id/edit" element={<UpdateClientView />}></Route>

        <Route path="/gestion-rdv/liste" element={<ListAppointmentsView />}></Route>
        <Route path="/gestion-rdv/:id/details" element={<ShowAppointementView />}></Route>

        <Route path="/gestion-admins/liste" element={<ListAdminsView />}></Route>
        <Route path="/gestion-admins/create" element={<CreateAdminView />}></Route>
        <Route path="/gestion-admins/:id/edit" element={<UpdateAdminView />}></Route>
        <Route path="/gestion-admins/:id/details" element={<ShowAdminView />}></Route>

        
        <Route path="/parametres" element={<SettingsView />}></Route>
        

        <Route path="/annonces/categories" element={<ListCategoriesView />}></Route>
        <Route path="/annonces/categories/creation" element={<CreateCategoryView />}></Route>
        <Route path="/annonces/categories/:id/edit" element={<UpdateCategoryView />}></Route>
        <Route path="/annonces/categories/:id/details" element={<ShowCategoryView />}></Route>

        <Route path="/annonces" element={<ListAnnouncementsView />}></Route>
        <Route path="/annonce/ajouter" element={<AddAnnonce />}></Route>
        <Route path="/annonce/:id/details-quiz" element={<AnnonceDetails />}></Route>
        <Route path="/annonce/:id/edit" element={<EditAnnonce />}></Route>

        <Route path="/annonce/:id/details" element={<ShowAnnouncement />}></Route>

        <Route path="/commission" element={<UpdateCommissionView />}></Route>
        <Route path="/commandes" element={<ListCommandesView />}></Route>
        <Route path="/ajouter-commande" element={<CreateCommandeView />}></Route>
        <Route path="/commande/:id/modifier" element={<UpdateCommandeView />}></Route>
        <Route path="/commandes/:id/details" element={<DetailsCommandeView />}></Route>

        <Route path="/factures" element={<ListFacturesView />}></Route>
        <Route path="/factures/:id/details" element={<DetailsFactureView />}></Route>

        <Route path="/conditions-generales" element={<ListConditionsGeneralesView />}></Route>
        <Route path="/conditions-generales/ajouter" element={<CreateConditionGeneraleView />}></Route>
        <Route path="/conditions-generales/:id/modifier" element={<UpdateConditionGeneraleView />}></Route>
        <Route path="/conditions-generales/:id/details" element={<DetailsConditionGeneraleView />}></Route>

        <Route path="/formations" element={<FormationList />}></Route>
        <Route path="/formation/ajouter" element={<AddFormation />}></Route>
        <Route path="/formation/:id/details-quiz" element={<FormationDetails />}></Route>
        <Route path="/formation/:id/edit" element={<EditFormation />}></Route>

        <Route path="/frais-abonnements" element={<ListFraisAbonnementsView />}></Route>

        <Route path="/devises" element={<ListDevisesView />}></Route>
        <Route path="/devises/ajouter" element={<CreateDeviseView />}></Route>
        <Route path="/devises/:id/modifier" element={<UpdateDeviseView />}></Route>
        <Route path="/devises/:id/details" element={<DetailsDeviseView />}></Route>

      </Routes>
    
    </BrowserRouter>
  );
}

export default App;
